export default __webpack_public_path__ + "static/media/3-2.d26e5b80.jpg";